export default __webpack_public_path__ + "static/media/lightning2.735b6379.png";